class Service {
  constructor(baseUrl, request) {
    this.request = request || (typeof window !== 'undefined' ? fetch.bind(window) : fetch);
    this.baseUrl = baseUrl;
    this._defaultConfig = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      cache: 'default'
    };
  }

  _serialize(params) {
    if (!params) return '';
    const serialized = encodeURI(Object.keys(params)
      .filter(key => !!params[key])
      .map(key => `${key}=${(params[key] || '')}`)
      .join('&'));
    return serialized.length > 0 ? '?' + serialized : '';
  }

  get(url, params, requestConfig = {}) {
    return this.request(url + this._serialize(params), { ...this._defaultConfig, ...requestConfig });
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/helpers/wp-api/service.js